module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "primary-header"
  }, [_c('h1', {
    attrs: {
      "data-qa": "Content-Export-Title"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.componentTitle) + "\n      "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.description))])])]), _vm._v(" "), _c('div', [_c('el-date-picker', {
    attrs: {
      "picker-options": _vm.pickerOptions,
      "end-placeholder": "End Date",
      "start-placeholder": "Start Date",
      "type": "daterange"
    },
    on: {
      "change": function($event) {
        _vm.onPickerChange(_vm.dateRange)
      }
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.isExportDisabled,
      "type": "warning"
    },
    on: {
      "click": function($event) {
        _vm.exportData(_vm.dateRange)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('exportButton')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.error))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8df1e0ec","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Export/Export.vue
// module id = 978
// module chunks = 3